<template>
  <div>

    <!-- DEFAULT CHECKBOX -->
    <div class="mb-4 bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Default Checkbox </h5>
        <p class="text-gray-500">Just a basic checkbox</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : view === 'preview'}" @click="view = 'preview'">Preview</b-button>
        <b-button :class="{'active' : view === 'code'}"  @click="view = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="view" :codeSample="require('@/components/local/Checkbox/checkbox.js').default">
      <template v-slot:preview>
        <div class="w-100 bg-gray-100">
            <Checkbox
              text="Sample"
              v-model="checkbox"
            >
            </Checkbox>
            <div class="mt-2">Value: <strong>{{ checkbox }}</strong></div>
        </div>
      </template>
    </CodePreviewViewer>
    </div>



    <!-- CUSTOM CHECKBOX -->
    <div class="mb-4 bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Checkbox With Custom Values </h5>
        <p class="text-gray-500">Checkbox with custom true and false values</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewCustom === 'preview'}" @click="viewCustom = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewCustom === 'code'}"  @click="viewCustom = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="viewCustom" :codeSample="require('@/components/local/Checkbox/checkbox_custom.js').default">
      <template v-slot:preview>
        <div class="w-100 bg-gray-100">
              <Checkbox
                text="I accept the terms and conditions"
                true-value="accepted"
                false-value="not_accepted"
                v-model="checkboxCustom"
              >
              </Checkbox>

              <div class="mt-2">Value: <strong>{{ checkboxCustom }}</strong></div>
        </div>
      </template>
    </CodePreviewViewer>
    </div>
    


    <!-- MULTIPLE CHECKBOXES -->
    <div class="mb-4 bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Multiple Checkboxes</h5>
        <p class="text-gray-500">Use this for multiple options or choices. This component renders stacked by default</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewMultiple === 'preview'}" @click="viewMultiple = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewMultiple === 'code'}"  @click="viewMultiple = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="viewMultiple" :codeSample="require('@/components/local/Checkbox/checkbox_multiple.js').default">
      <template v-slot:preview>
        <div class="w-100 bg-gray-100">
              <p class="mb-2">Individual Checkboxes Stacked (Default)</p>
              <Checkbox text="Orange" value="orange1" v-model="checkboxGroup"></Checkbox>
              <Checkbox text="Apple" value="apple1" v-model="checkboxGroup"></Checkbox>
              <Checkbox text="Pineapple" value="pineapple1" v-model="checkboxGroup"></Checkbox>
              <Checkbox text="Banana" value="banana1" v-model="checkboxGroup" disabled></Checkbox>

              <br><br>

              <p class="mb-2">Individual Checkboxes Inline</p>
              <Checkbox text="Orange" value="Orange" v-model="checkboxGroup" inline ></Checkbox>
              <Checkbox text="Apple" value="Apple" v-model="checkboxGroup" inline></Checkbox>
              <Checkbox text="Pineapple" value="Pineapple" v-model="checkboxGroup" inline></Checkbox>
              <Checkbox text="Banana" value="Banana" v-model="checkboxGroup" inline disabled></Checkbox>

              <br><br><br>

              <p class="mb-2">Array of Checkboxes Stacked (Default)</p>
              <Checkbox 
                v-model="checkboxGroup"
                v-for="(option, index) in options" 
                :option="option" 
                :key="index" 
                :text="option.text"
                :value="option.value"
                :disabled="option.disabled"
              >
              </Checkbox>

              <br><br>

              <p class="mb-2">Array of Checkboxes Inline</p>
              <Checkbox 
                v-model="checkboxGroup"
                v-for="option in options" 
                :option="option" 
                :key="option.value" 
                :text="option.text"
                :value="option.value"
                :disabled="option.disabled"
                inline
              >
              </Checkbox>

              <div class="mt-5">Values: <strong>{{ checkboxGroup }}</strong></div>
        </div>
      </template>
    </CodePreviewViewer>
    </div>



    <!-- MULTISELECTION CHECKBOXES -->
    <div class="mb-4 bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Multiselection of Checkboxes</h5>
        <p class="text-gray-500">
          Ability to multi select or unselect a group of checkboxes. Uses the <span class="text-red">indeterminate</span> state.<br>
          <a href="https://bootstrap-vue.org/docs/components/form-checkbox#indeterminate-tri-state-support">Know more about indeterminate ></a>
        </p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewSelect === 'preview'}" @click="viewSelect = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewSelect === 'code'}"  @click="viewSelect = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="viewSelect" :codeSample="require('@/components/local/Checkbox/checkbox_select.js').default">
      <template v-slot:preview>
        <div class="w-100 bg-gray-100">
              <Checkbox
                v-model="allSelected"
                :indeterminate="indeterminate"
                @change="toggleAll"        
              >
                {{ allSelected ? 'Unselect All' : 'Select All' }}
              </Checkbox>
    
              <br>

              <Checkbox 
                v-model="selected"
                v-for="fruit in fruits" 
              
                :key="fruit.value" 
                :text="fruit.text"
                :value="fruit.value"
              >
              </Checkbox>

              <div class="mt-5">
                Selected: <strong>{{ selected }}</strong><br>
                All Selected: <strong>{{ allSelected }}</strong><br>
                Indeterminate: <strong>{{ indeterminate }}</strong>
              </div>
        </div>
      </template>
     </CodePreviewViewer>
    </div>  
  
    

    <!-- SIZING -->
    <div class="mb-4 bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Sizing</h5>
        <p class="text-gray-500">Use the size prop to control the size of the checkbox</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewSizing === 'preview'}" @click="viewSizing = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewSizing === 'code'}"  @click="viewSizing = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="viewSizing" :codeSample="require('@/components/local/Checkbox/checkbox_sizing.js').default">
      <template v-slot:preview>
        <div class="w-100 bg-gray-100">
            <Checkbox text="Small" size="sm"></Checkbox>
            <Checkbox text="Default"></Checkbox>
            <Checkbox text="Large" size="lg"></Checkbox>
        </div>
      </template>
    </CodePreviewViewer>
    </div>
  </div>
</template>


<script>
import Checkbox from '@/components/export/Checkbox/Checkbox'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'

export default {
  components: { Checkbox, ButtonGroup,CodePreviewViewer },

  data() {
      return {
        view: 'preview',
        viewCustom: 'preview',
        viewMultiple: 'preview',
        viewSelect: 'preview',
        viewSizing: 'preview',
        checkbox: false,
        checkboxCustom: 'not_accepted',
        checkboxGroup: [],
        options: [
          { text: 'Orange', value: 'Orange', disabled: false },
          { text: 'Apple', value: 'Apple', disabled: false },
          { text: 'Pineapple', value: 'Pineapple', disabled: false },
          { text: 'Banana', value: 'Banana', disabled: true}
        ],
        fruits: [
          { text: 'Orange', value: 'Orange' },
          { text: 'Apple',value: 'Apple' },
          { text: 'Pineapple', value: 'Pineapple' },
          { text: 'Watermelon', value: 'Watermelon' },
          { text: 'Coconut',value: 'Coconut' },
          { text: 'Avocado', value: 'Avocado' },
        ],
        selected: [],
        allSelected: false,
        indeterminate: false
      }
  },

  methods: {
    toggleAll(checked) {
        let result = this.fruits.map(({ value }) => value)
        this.selected = checked ? result : []
    }
  },

  watch: {
    selected(newValue) {
      // Handle changes in individual fruit checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length === this.fruits.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    }
  }
}
</script>